"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (num) => {
    let total = num;
    if (num >= 1000 && num < 1000000) {
        total = `${Math.floor((num / 1000) * Math.pow(10, 1)) / Math.pow(10, 1)}K`;
    }
    else if (num >= 1000000) {
        total = `${Math.floor((num / 1000000) * Math.pow(10, 1)) / Math.pow(10, 1)}M`;
    }
    return total.toString();
};
